import{gql as e}from"@apollo/client";const s=e`
  mutation answerCustomFields($projectId: String!, $responses: [CustomFieldResponseInputType!]!, $userId: Int) {
    customFieldResponse {
      answerCustomFields(projectId: $projectId, reponses: $responses, userId: $userId)
    }
  }
`;export{s as ANSWER_CUSTOM_FIELDS_MUTATION};
//# sourceMappingURL=useAnswerCustomFields.graphql.js.map
